// import React, { useState } from 'react';
// import { 
//   IconButton, 
//   Tooltip, 
//   Box,
//   useTheme as useMuiTheme,
//   alpha
// } from '@mui/material';
// import { 
//   LightMode as LightModeIcon, 
//   DarkMode as DarkModeIcon 
// } from '@mui/icons-material';
// import { useTheme } from '../../contexts/ThemeContext';

// interface ThemeToggleProps {
//   size?: 'small' | 'medium' | 'large';
//   showTooltip?: boolean;
// }

// const ThemeToggle: React.FC<ThemeToggleProps> = ({ 
//   size = 'medium', 
//   showTooltip = true 
// }) => {
//   const { theme, toggleTheme } = useTheme();
//   const muiTheme = useMuiTheme();
//   const [isAnimating, setIsAnimating] = useState(false);
//   const iconStyle = {
//     fontSize: '1.2rem',
//     color: theme === 'dark' ? '#FFD700' : '#ffffff', // Gold icon on dark, white icon on light
//     transition: 'transform 0.3s',
//     transform: isAnimating ? 'scale(1.2) rotate(360deg)' : 'scale(1)',
//   };
//   const isDark = theme === 'PureDarkTheme';
  
//   const iconSize = size === 'small' ? 20 : size === 'large' ? 28 : 24;
  
//   const button = (
//     <IconButton
//       onClick={toggleTheme}
//       sx={{
//         width: 40,
//         height: 40,
//         borderRadius: 1,
//         padding: 0,
//         backgroundColor: theme === 'dark' ? '#2E3B55' : '#1976d2',  // Dark blue on dark, primary blue on light
//         transition: 'background-color 0.3s',
//         '&:hover': {
//           backgroundColor: theme === 'dark' ? '#3F4E7F' : '#115293',  // Lighter blue hover on dark, darker blue on light
//         },
//         '&:active': {
//           backgroundColor: theme === 'dark' ? '#1F2A40' : '#0D3A6B',  // Even darker on press
//         },
//         '&:disabled': {
//           backgroundColor: theme === 'dark' ? '#444F6A' : '#90CAF9',  // Muted colors for disabled
//         },
//       }}
//     >
      
//         {isDark ? (
//           <DarkModeIcon 
//           style={iconStyle}
//           />
//         ) : (
//           <LightModeIcon 
//           style={iconStyle}
//           />
//         )}
//     </IconButton>
//   );

//   if (showTooltip) {
//     return (
//       <Tooltip 
//         title={isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
//         arrow
//         placement="bottom"
//       >
//         {button}
//       </Tooltip>
//     );
//   }

//   return button;
// };

// export default ThemeToggle;


import React from 'react';
import { 
  IconButton, 
  Tooltip 
} from '@mui/material';
import { LightMode as LightModeIcon } from '@mui/icons-material';

interface ThemeToggleProps {
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ 
  size = 'medium', 
  showTooltip = true 
}) => {
  const iconSize = size === 'small' ? 20 : size === 'large' ? 28 : 24;

  const button = (
    <IconButton
      disabled // disable toggle since you want fixed light mode
      sx={{
        width: 40,
        height: 40,
        borderRadius: 1,
        padding: 0,
        backgroundColor: '#1976d2', // always light mode primary
        color: '#fff',
        '&:hover': {
          backgroundColor: '#115293',
        },
      }}
    >
      <LightModeIcon style={{ fontSize: iconSize }} />
    </IconButton>
  );

  if (showTooltip) {
    return (
      <Tooltip 
        title="Light Mode Enabled"
        arrow
        placement="bottom"
      >
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default ThemeToggle;
